import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { LocationsResource } from 'src/client'
import logger from 'src/utils/logger'

const useUpdateLoopConfigurationsMutation = (locationId: number) => {
  const queryClient = useQueryClient()

  return useMutation(LocationsResource.updateLoopConfigurations, {
    onSuccess: async () => {
      toast.success('Business terminology updated')

      try {
        await queryClient.invalidateQueries({
          queryKey: ['loop-configurations', { locationId }],
        })
      } catch (error) {
        logger.error(
          'There was an error trying to refresh the Business Terminology.',
          { error }
        )
      }
    },
    onError: (error) => {
      logger.error(
        'There was an error trying to update the Business Terminology.',
        { error }
      )
    },
  })
}

export default useUpdateLoopConfigurationsMutation
